import { Injectable, signal } from '@angular/core'
import { Clipboard } from '@capacitor/clipboard'
import { localTime } from '@naturalcycles/js-lib'

@Injectable({ providedIn: 'root' })
export class LogService {
  public bleLogs = signal<string[]>([])

  /**
   * Only to be called from Bluetooth Device Services
   */
  public logBleAction(message: string): void {
    const logs = [...this.bleLogs()]
    logs.push(`${localTime.now().toPretty()} ${message}`)
    this.bleLogs.set(logs)
    console.log(`[ble] ${message}`)
  }

  public clearBleLogs(): void {
    this.bleLogs.set([])
  }

  public async copyBleLogsToClipboard(): Promise<void> {
    await Clipboard.write({
      // eslint-disable-next-line id-blacklist
      string: this.bleLogs().join('\n'),
    })
  }
}
